/* eslint-disable import/no-anonymous-default-export */
import { MissionTab } from './MissionTab';
import { MissionShow } from './show/MissionShow';
import { MissionCreate } from './edit/MissionCreate';
import { MissionEdit } from './edit/MissionEdit';

export default {
    list: MissionTab,
    show: MissionShow,
    create: MissionCreate,
    edit: MissionEdit,
};
